import React from "react";
import { Controller, useForm } from "react-hook-form";

import { SettingsInput } from "../../../../components/inputs/SettingsInput";
import { Modal } from "../../../../components/modal/Modal";
import { Button } from "../../../../components/newUI/button";

type Props = {
  onClose: () => void;
  onSubmit: (subStatusName: string) => Promise<void>;
  isLoading: boolean;
};

type FormData = {
  subStatusName: string;
};

export const CreateNewStatus: React.FC<Props> = ({
  onClose,
  onSubmit,
  isLoading,
}) => {
  const { control, handleSubmit, watch } = useForm<FormData>({
    defaultValues: { subStatusName: "" },
  });

  const onSave = async (formData: FormData) => {
    await onSubmit(formData.subStatusName);
  };

  return (
    <Modal onClose={onClose} width={"440px"}>
      <p className={"mb-2 text-xl font-semibold text-[#1D2C3B]"}>
        Create New Status
      </p>
      <p className={"mb-4 text-sm text-[#5F758F]"}>
        This status will be available for this work type immediately. You can
        add it to other work types later.
      </p>
      <div>
        <Controller
          control={control}
          rules={{
            required: "This field is required",
          }}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <SettingsInput
              value={value}
              isError={!!error}
              onChange={(e) => onChange(e.target.value)}
              label={"Status Name"}
              placeholder={"Status Name..."}
              inputClasses={"w-full"}
            />
          )}
          name={"subStatusName"}
        />
      </div>
      <div className={"mt-8 flex justify-center gap-3 text-sm font-semibold"}>
        <Button
          type={"button"}
          variant={"outline"}
          fullWidth
          disabled={isLoading}
          onClick={onClose}
          className={
            "border-[#C8D2DE] px-4 text-[#253747] hover:border-[#C8D2DE] hover:bg-white disabled:opacity-75"
          }>
          Cancel
        </Button>
        <Button
          type={"button"}
          fullWidth
          loading={isLoading}
          disabled={isLoading || !watch("subStatusName")}
          onClick={() => handleSubmit(onSave)()}
          className={
            "border-[#6938EF] bg-[#6938EF] px-4 text-white hover:border-[#6938EF] hover:bg-[#6938EF] disabled:border-[#6938EF] disabled:bg-[#6938EF] disabled:opacity-75"
          }>
          Save
        </Button>
      </div>
    </Modal>
  );
};
